/**
 * @author Kvadrat
 * This file contains code copied from:
 * https://github.com/inter-ikea/cbf-re-ipex-kvadrat
 *
 * This file includes one additional function toDisplayIn
 * that @jonasberglund created for SKYTTA
 */

import { inToInFr } from './convert';

/**
 * Extracted single function from https://github.com/inter-ikea/cbf-re-ipex-skytta/blob/main/src/utils/mathUtil.ts#L13
 * @param num The number to round
 * @param decimalPlaces The number of decimal places to preserve
 */
function round(num: number, decimalPlaces: number): number {
  const decimal = 10 ** decimalPlaces;
  return Math.round(num * decimal) / decimal;
}

/**
 * Format centimeters
 * @param value Centimeters
 * @param locale locale of the user
 * @param decimalPlaces the number of decimals to round to
 * @returns Formatted centimeters
 */
function toDisplayCm(value: number, locale = 'sv-SE', decimalPlaces = 1): string {
  const numberFormatter = new Intl.NumberFormat(locale); // Retrieve from i18n...

  if (value !== null && !isNaN(value)) {
    return numberFormatter.format(decimalPlaces >= 0 ? round(value, decimalPlaces) : value);
  }

  return '';
}

/**
 * Format inches as inches and fractions
 * @param value Inches
 * @returns Formatted feet and inches
 */
function toDisplayIn(value: number): string {
  if (!Number.isNaN(value) && value >= 0) {
    const { inches, fractions } = inToInFr(value);

    const values: Array<string | number> = [];

    if (inches) {
      if (fractions) {
        values.push(inches);
      } else {
        values.push(`${inches}"`);
      }
    }

    if (fractions) {
      values.push(`${fractions}"`);
    }

    const result = values
      .filter(Boolean) // Remove empty or 0 results
      .join(' ');

    return result || `0"`;
  }

  return '';
}

export { toDisplayCm, toDisplayIn };
